import { ChangeDetectorRef, Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DeleteDialogComponent } from 'app/core/shared/component/delete-dialog/delete-dialog.component';
import { ExcelService } from 'app/core/shared/services/file.service';
import { AddOptionTypeComponent } from 'app/modules/option-type/component/add-option-type/add-option-type.component';
import { EditOptionTypeComponent } from 'app/modules/option-type/component/edit-option-type/edit-option-type.component';
import { OptionTypeService } from 'app/modules/option-type/services/option-type.service';
import module from 'app/modules/option-type/option-type.module';

@Component({
    selector: 'app-daily-activity-tracker',
    templateUrl: './index.page.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: module,
    styleUrls: ['./index.page.scss'],
})
export class IndexPage {
    public options$: any = this.metadataService.options$
  
    public filterData = {
      pageNumber: 1,
      pageSize: 10,
      wellName: '',
      reportType: '',
      startDate: null,// new Date(),
      endDate: null
    }
  
    constructor(
      private elementRef: ElementRef,
      public dialog: MatDialog,
      private router: Router,
      private cdr: ChangeDetectorRef,
      private fileService: ExcelService,
      private metadataService: OptionTypeService) { }
  
    ngOnInit() {
      this.getOptions()
    }
  
    getOptions() {
      this.metadataService.getOptions(this.filterData.pageNumber, this.filterData.pageSize).subscribe()
    }
  
    nextPage() {
      this.filterData.pageNumber = this.filterData.pageNumber + 1
      this.getOptions()
    }
  
    previousPage() {
      this.filterData.pageNumber = this.filterData.pageNumber - 1
      this.getOptions()
    }
  
    navigateToDetailsPage(optionId: any, categoryName: string, detailsData: any): void {
  
      this.router.navigate(['/configurations/option-type/option-type-details'], {
        queryParams: {
          optionId: optionId,
        }
      }); // Specify the route path to navigate to
    }
  
    editOptionType(categoryData: any) {
      const dialogRef = this.dialog.open(EditOptionTypeComponent, {
        data: categoryData, // Pass your parameters here
        width: "50%"
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.getOptions()
        }
      });
    }
  
    addOptions() {
      const dialogRef = this.dialog.open(AddOptionTypeComponent, {
        width: "50%"
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.getOptions()
        }
      });
    }
  
    deleteOptionType(id: any): void {
      const dialogRef = this.dialog.open(DeleteDialogComponent);
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.metadataService.deleteOption(id).subscribe((res) => {
            this.getOptions()
          })
        }
      });
    }
  
    exportToExcel() {
      this.options$.subscribe(options => {
        this.fileService.exportToExcel(options.data, 'Option Type', 'Option Type')
      })
    }
}
